import React from 'react';
const FluidIcon = (props) => (React.createElement("svg", { className: props.className, style: props.style, viewBox: "0 0 31.934 31.934" },
    React.createElement("g", { fill: "none", stroke: "currentColor", "stroke-width": "3", transform: "translate(-.033 -.033)" },
        React.createElement("rect", { width: "28.934", height: "28.934", x: "1.533", y: "1.533", "stroke-linecap": "round", "stroke-linejoin": "round", "paint-order": "stroke fill markers", rx: "4", ry: "4" }),
        React.createElement("path", { d: "M10.507 1.317V30.01M11.055 18.807h19.22" }))));
export default FluidIcon;
